import { NotOverridableComponentProps } from '../../../../../model/Component'
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import { TranslatableBox, TranslatableBoxProps } from '../../../../../feature/localization/component/atom/TranslatableBox'

export type AppMenuItemProps = NotOverridableComponentProps<MenuItemProps & TranslatableBoxProps>

export function AppMenuItem(props: AppMenuItemProps) {
  return <TranslatableBox component={MenuItem} {...props} />
}
